import ReactDOM from "react-dom/client";
import "react-datepicker/dist/react-datepicker.css";
import { withLDProvider } from "launchdarkly-react-client-sdk";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { getLaunchDarklyClientId, launchDarklyConfig } from "./config/launchDarkly";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const AppWithFlags = getLaunchDarklyClientId() ? withLDProvider(launchDarklyConfig)(App) : App;

root.render(
	<Provider store={store}>
		<BrowserRouter>
			<AppWithFlags />
		</BrowserRouter>
	</Provider>,
);
